import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@insurancemenu/imenu-components-lib';
import { ArrowBack } from '@insurancemenu/imenu-components-lib/dist/icons';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';
import { ProposalConfirmationStatus } from 'store/ui-stores/proposal-v2/proposalItemsStore';
import { createStyles } from './styles';

const EmployerProposalPageHeader = observer((): JSX.Element => {
  const history = useHistory();

  // Mobx store
  const {
    proposalItemsStore: { proposalConfirmationStatus },
  } = useRootStore();

  const onBackRedirect = (): void => {
    history.goBack();
  };

  const classes = createStyles();

  const HeaderLayout = (): JSX.Element => {
    switch (proposalConfirmationStatus) {
      case ProposalConfirmationStatus.NEW:
        return (
          <>
            <h1 className={classes.title}>Review & Confirm Quote</h1>
            <h2 className={classes.subTitle}>Select the final products for this client</h2>
          </>
        );

      default:
        return <h1 className={classes.title}>Quote</h1>;
    }
  };

  return (
    <header className={classes.header}>
      <Button
        type="text"
        size="medium"
        onClick={onBackRedirect}
        leftIconProp={<ArrowBack />}
        className={classes.backButton}
      >
        Back
      </Button>
      {HeaderLayout()}
    </header>
  );
});

export default EmployerProposalPageHeader;
